import router from '@/router'
import store from '@/store'
/**
 * 免登录白名单
 */
const whiteList:string[] = ['/login','/basy']
/**
 * 路由前置处理
 */
router.beforeEach(async (to, from, next) => {
  // if (store.getters.token) {
  console.log(store.getters.orgId)
    // if (to.path === '/main/index' && store.getters.orgId==1000) {
    //   next()
    //   next('/')
    // } else if (to.path === '/main/index' && store.getters.orgId>1000) {
    //   next({path:'/main/index-old',query:to.query})
    // }else{
    //   next()
    // }
  //   if(!store.getters.hasUserInfo){
  //       await store.dispatch('user/getUserInfo')

  //   }
  // } else {
  //   if (whiteList.indexOf(to.path) > -1) {
  //     next()
  //   } else {
  //     next('/login')
  //   }
  // }
  next()
})
